import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { GridOverlay } from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import {
  BID_ADMIN_PAGE_TYPE,
  BID_AWARD_NO_BID_PAGE_TYPE,
  BID_CHOICES_PAGE_TYPE,
  BID_GROUP_PAGE_TYPE,
  BID_LINES_PAGE_TYPE,
  BID_PAGE_TYPE,
  CREATE_BID_PAGE_TYPE,
  SENIORITY_LIST_PAGE_TYPE,
  TEMPORARY_ASSIGNMENT_PAGE_TYPE,
  TIME_OFF_PAGE_TYPE,
  TRADE_PAGE_TYPE,
  DECLARATION_PAGE_TYPE,
} from "../util/constants";
import NoBidsImage from "./bid/NoBidsImage";
import NoShiftLinesImage from "./bid/NoShiftLinesImage";
import NoDeclarationsImage from "./NoDeclarationsImage";
import NoEmployeesImage from "./NoEmployeesImage";
import NoTemporaryAssignmentsImage from "./NoTemporaryAssignmentsImage";
import NoTimeOffRequestImage from "./NoTimeOffRequestsImage";
import NoTradesImage from "./NoTradesImage";
import { VOLUNTARY_OT_PAGE } from "../util/overtime/constants";
import NoSignupsImage from "./overtime/NoSignupsImage";

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        flexDirection: "column",
      },
    }),
  { defaultTheme }
);

const CustomNoRowsTableOverlay = (props) => {
  const classes = useStyles();

  const renderImage = () => {
    switch (props.pageType) {
      case TRADE_PAGE_TYPE:
        return <NoTradesImage />;
      case TIME_OFF_PAGE_TYPE:
        return (
          <NoTimeOffRequestImage
            isAdminPage={props.isAdminPage}
            isWOPTable={props.isWOPTable}
            isWOPListFrozen={props.isWOPListFrozen}
            isDesktopView={props.isDesktopView}
          />
        );
      case TEMPORARY_ASSIGNMENT_PAGE_TYPE:
        return <NoTemporaryAssignmentsImage />;
      case SENIORITY_LIST_PAGE_TYPE:
        return (
          <NoEmployeesImage
            isEmployeeView={props.isEmployeeView}
            seniorityListFtPtCount={props.seniorityListFtPtCount}
          />
        );
      case BID_PAGE_TYPE:
        return <NoBidsImage message="No Bids" />;
      case BID_ADMIN_PAGE_TYPE:
        return <NoBidsImage message="No Bids" />;
      case BID_GROUP_PAGE_TYPE:
        return <NoBidsImage message="No Bid Group" />;
      case BID_LINES_PAGE_TYPE:
        return <NoBidsImage message="No Bid Lines" />;
      case BID_CHOICES_PAGE_TYPE:
        return <NoBidsImage message="No Choices" />;
      case BID_AWARD_NO_BID_PAGE_TYPE:
        return <NoBidsImage message="No Employees" />;
      case CREATE_BID_PAGE_TYPE:
        return <NoShiftLinesImage />;
      case DECLARATION_PAGE_TYPE:
        return <NoDeclarationsImage />;
      case VOLUNTARY_OT_PAGE:
        return <NoSignupsImage />;
      default:
        return <div></div>;
    }
  };

  return <GridOverlay className={classes.root}>{renderImage()}</GridOverlay>;
};

CustomNoRowsTableOverlay.propTypes = {
  pageType: PropTypes.string.isRequired,
  isWOPTable: PropTypes.bool,
  isWOPListFrozen: PropTypes.bool,
  isAdminPage: PropTypes.bool,
  isEmployeeView: PropTypes.bool,
  seniorityListFtPtCount: PropTypes.any,
  isDesktopView: PropTypes.bool,
};

export default CustomNoRowsTableOverlay;
